import React from 'react'
import { Table } from "@q4us-sw/q4us-ui";
import {error_log_report, getFeConfig, visualize} from "../api/api";
import {Button, PageHeader} from 'antd'
import {DefaultProps, PaginatedLoad, Refresh, RefTable} from "./RefTable";
import {DownloadOutlined} from "@ant-design/icons";


export const EnumV1 = (props) => {

    return <React.Fragment>
        <PageHeader title="Enums"/>
        <Table
            fetchConfig={async () => {
                return await getFeConfig("enums")
            }}
            fetchData={async () => {
                return await visualize("enums")
            }}
            editable={false}
            scroll={{y: 'calc(90vh - 20px)', x: 'max-content' }}
            source={{
                container: [],
                columns: [],
                action: "config",
                edit: {}
            }}
        />
    </React.Fragment>
}


export const Enum = (props)=><RefTable {...props}/>;

Enum.defaultProps = {
    ...DefaultProps,
    title: "Enums",
    tableSchema: "enums",
    tableName: "enums",
    edit: false,
    add: false,
    theadHeight: 40,
    customRenderer:{
        values:  (value, row, index, column, editable)=>{
            return <div style={{maxWidth: 'calc(100vw - 240px)', wordWrap: 'word-break', textAlign: 'left'}}>
                {value.map(o=>o.join("=>")).join(", ")}
            </div>
        }
    }
}
